/**
 * Extrae el `short` de yourls de una URL codificada en un QR.
 * El QR de un avatar/MC codifica `mc.yourls.url`; el `short` es el último
 * segmento de la ruta. Es tolerante a query strings, hash y barra final.
 */
export function extractShortFromUrl(input: string): string {
    const trimmed = (input || '').trim();
    if (!trimmed) return '';
    const withoutQuery = trimmed.split('?')[0].split('#')[0];
    const parts = withoutQuery.split('/').filter(Boolean);
    return parts.length ? parts[parts.length - 1] : trimmed;
}
